import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common/http';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import Auth0Lock from 'auth0-lock';
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of } from "rxjs";
import { filter, catchError } from 'rxjs/operators';
import { BF_AUTH_CONFIG, BF_AUTH_CONFIG_OPTIONS } from '../bf-auth-config';
import { BfAuthJwtHelper } from '../bf-auth-jwt-helper';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
import * as i3 from "../bf-auth-config/bf-auth.config";
var BfAuthService = /** @class */ (function () {
    function BfAuthService(router, http, bfAuthConfig, authConfigOptions) {
        var _this = this;
        this.router = router;
        this.http = http;
        this.bfAuthConfig = bfAuthConfig;
        this.authConfigOptions = authConfigOptions;
        this.auth0AuthenticatedSubject = new BehaviorSubject(false);
        // Original base stuff starts here:
        this.initProfile = { name: "", nickname: "", picture: "", user_id: "", given_name: "", family_name: "", email: "", email_verified: false, clientID: "", gender: "", identities: [], created_at: "", updated_at: "", sub: "", user_metadata: {}, app_metadata: {} };
        this.tokenSubject = new BehaviorSubject("");
        this.delegateTokensSubject = new BehaviorSubject([]);
        this.profileIdSubject = new BehaviorSubject(0);
        this.departmentIdSubject = new BehaviorSubject(0);
        this.firstnameSubject = new BehaviorSubject("");
        this.surnameSubject = new BehaviorSubject("");
        this.roleSubject = new BehaviorSubject("");
        this.pictureSubject = new BehaviorSubject("");
        this.emailSubject = new BehaviorSubject("");
        this.departmentSubject = new BehaviorSubject("");
        this.permissionsSubject = new BehaviorSubject([]);
        this.profileSubject = new BehaviorSubject(this.initProfile);
        this.errorSubject = new BehaviorSubject({});
        this.stateSubject = new BehaviorSubject("");
        this.auth0Error = this.errorSubject.asObservable();
        var authOptions = this.authConfigOptions || {};
        this.lock = new Auth0Lock(this.bfAuthConfig.Auth0.ClientId, this.bfAuthConfig.Auth0.Domain, authOptions);
        // if already authenticated, then id_token is set in the local storage
        if (this.authenticated()) {
            // 1. get tokens from local storage
            var idToken = localStorage.getItem("id_token");
            var accessToken = localStorage.getItem("access_token");
            // In scenarios where user is sso data : log into application B with application A token
            // and application B require more delegate token than application A
            // then
            // a. user will be already login single sign on (sso) into application B
            // b. application B will use needed delegate tokens from application A
            // c. additional needed delegate tokens will be requested from Auth0, if the token(s) is required and fail the user will be logout
            // 2. ensure that current application delegate tokens are set
            this.setDelegateTokensAsync(idToken, accessToken);
            // 3. save additional token into local storage
            this.delegateTokensAsync
                .pipe(
            // 3.1. check that all delegate tokens counts are equal to DelegateClients config counts
            filter(function (delegate) { return delegate.length == _this.bfAuthConfig.DelegateClients.length; }))
                .subscribe(function (delegates) {
                // 3.2. get all failed delegate tokens and required
                var failedDelegates = delegates
                    .filter(function (del) { return (del.id_token == null || del.id_token == "") && _this.bfAuthConfig.DelegateClients.some(function (delC) { return delC.Auth0.AppName == del.AppName && delC.Auth0.Required; }); });
                // 3.3. if one of the failed delegate is for required application logout the user
                if (failedDelegates && failedDelegates.length >= 1) {
                    _this.logout();
                }
                else {
                    delegates.forEach(function (del) {
                        var delegateTokenId = "id_token_delegate_" + del.AppName;
                        var delegateTokenExist = localStorage.getItem(delegateTokenId);
                        if (!delegateTokenExist)
                            localStorage.setItem(delegateTokenId, del.id_token);
                    });
                }
            }, function (error) {
                _this.errorSubject.next(error);
            });
            // 4. set user profile
            this.setProfileAsync(idToken);
            // 5. raise token event
            this.tokenSubject.next(idToken);
            if (window.location.pathname == '/')
                this.navigate(this.bfAuthConfig.HomePageURL);
        }
    }
    /**
     * show lock login widget
     */
    BfAuthService.prototype.login = function () {
        // check if coming back from auth0
        var callbackRgx = new RegExp('/access_token|id_token|error/');
        var isCallback = callbackRgx.test(this.router.url);
        // only show popup if one of below is true
        // a. not callback: token in url but lock yet to raise authenticated event
        // b. lock yet to raise authenticated event
        // c. user not currently authenticated
        var isAuthenticated = this.authenticated();
        if (isAuthenticated == true && window.location.pathname == '/')
            this.navigate(this.bfAuthConfig.HomePageURL);
        if (this.auth0AuthenticatedSubject.value == false
            && isCallback == false
            && isAuthenticated == false)
            this.lock.show();
    };
    ;
    /**
     * handle authentication callback and set app data
     */
    BfAuthService.prototype.handleAuthentication = function () {
        var _this = this;
        this.lock.on('authenticated', function (authResult) {
            // once authentication is established raise auth0 authenticated event
            _this.auth0AuthenticatedSubject.next(true);
            // 1. first ensure delegate tokens are set - using the access token which holds the details to access the grouped APIs
            _this.setDelegateTokensAsync(authResult.idToken, authResult.accessToken);
            // 5. re route
            _this.reRoute(authResult);
        });
        this.lock.on('authorization_error', function (err) {
            _this.lock.show({ flashMessage: { type: 'error', text: err.errorDescription } });
        });
    };
    BfAuthService.prototype.reRoute = function (authResult) {
        var _this = this;
        if (authResult && authResult.idToken && (!this.bfAuthConfig.DelegateClients || this.bfAuthConfig.DelegateClients.length == 0))
            this.setDataAndReRoute(authResult);
        if (authResult && authResult.idToken && this.bfAuthConfig.DelegateClients && this.bfAuthConfig.DelegateClients.length > 0) {
            this.delegateTokensAsync
                .pipe(
            // 1. check that all delegate tokens counts are equal to DelegateClients config counts
            filter(function (delegate) { return delegate.length == _this.bfAuthConfig.DelegateClients.length; }))
                .subscribe(function (delegates) {
                // 2. get all failed delegate tokens and required
                var failedDelegates = delegates
                    .filter(function (del) { return (del.id_token == null || del.id_token == "") && _this.bfAuthConfig.DelegateClients.some(function (cfg) { return cfg.Auth0.AppName == del.AppName && cfg.Auth0.Required; }); });
                // 3. if one of the failed delegate is for required application throw exception
                if (failedDelegates && failedDelegates.length >= 1) {
                    // 3.1 show auth0 widget with error message
                    _this.lock.show({ flashMessage: { type: 'error', text: failedDelegates[0].Error + " - " + failedDelegates[0].AppName } });
                    _this.errorSubject.next("get delegate token for " + failedDelegates[0].AppName + " fails with " + failedDelegates[0].Error);
                }
                else {
                    delegates.forEach(function (del) { localStorage.setItem("id_token_delegate_" + del.AppName, del.id_token); });
                    _this.setDataAndReRoute(authResult);
                }
            }, function (error) {
                _this.errorSubject.next(error);
            });
        }
    };
    BfAuthService.prototype.setDataAndReRoute = function (authResult) {
        this.lock.hide();
        // 1. store idToken & accessToken in local storage which indicate authenticated() == true
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('access_token', authResult.accessToken);
        // 2. set user profile
        this.setProfileAsync(authResult.idToken);
        // 3. raise token event
        this.tokenSubject.next(authResult.idToken);
        // 4. set and raise redirect url state
        if (authResult && authResult.state && decodeURIComponent(authResult.state).startsWith('ru')) {
            var state = decodeURIComponent(authResult.state).replace('ru=', '');
            this.stateSubject.next(state);
            this.navigate(state);
        }
        else {
            this.navigate(this.bfAuthConfig.HomePageURL);
        }
    };
    BfAuthService.prototype.navigate = function (url) {
        if (!url.includes('?'))
            this.router.navigate([url]);
        if (url.includes('?')) {
            var queryString = url.split('?')[1];
            var strPath = url.split('?')[0];
            var keyValues = queryString.split('&');
            var params_1 = {};
            keyValues.forEach(function (keyValue) {
                var key = keyValue.split('=')[0];
                var value = keyValue.split('=')[1];
                params_1[key] = value;
            });
            var navQuery = { queryParams: params_1 };
            this.router.navigate([strPath], navQuery);
        }
    };
    Object.defineProperty(BfAuthService.prototype, "token", {
        get: function () {
            return this.tokenSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "tokenAsync", {
        get: function () {
            return this.tokenSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "delegateTokens", {
        get: function () {
            return this.delegateTokensSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "delegateTokensAsync", {
        get: function () {
            return this.delegateTokensSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "profileId", {
        get: function () {
            return this.profileIdSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "profileIdAsync", {
        get: function () {
            return this.profileIdSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "departmentId", {
        get: function () {
            return this.departmentIdSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "departmentIdAsync", {
        get: function () {
            return this.departmentIdSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "firstname", {
        get: function () {
            return this.firstnameSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "firstnameAsync", {
        get: function () {
            return this.firstnameSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "surname", {
        get: function () {
            return this.surnameSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "surnameAsync", {
        get: function () {
            return this.surnameSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "role", {
        get: function () {
            return this.roleSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "roleAsync", {
        get: function () {
            return this.roleSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "picture", {
        get: function () {
            return this.pictureSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "pictureAsync", {
        get: function () {
            return this.pictureSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "email", {
        get: function () {
            return this.emailSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "emailAsync", {
        get: function () {
            return this.emailSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "department", {
        get: function () {
            return this.departmentSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "departmentAsync", {
        get: function () {
            return this.departmentSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "profile", {
        get: function () {
            return this.profileSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "profileAsync", {
        get: function () {
            return this.profileSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "state", {
        get: function () {
            return this.stateSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "stateAsync", {
        get: function () {
            return this.stateSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "permissions", {
        get: function () {
            return this.permissionsSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BfAuthService.prototype, "permissionsAsync", {
        get: function () {
            return this.permissionsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * check that user has a permission
     * @param permission
     * @param appName
     * @return boolean
     */
    BfAuthService.prototype.hasPermission = function (permission, appName) {
        if (appName === void 0) { appName = this.bfAuthConfig.Auth0.AppName; }
        if (this.role == 'Admin')
            return true;
        if (this.profile && this.profile.app_metadata && this.profile.app_metadata.apps && appName && this.profile.app_metadata.apps.hasOwnProperty(appName)) {
            var appPermissions = this.profile.app_metadata.apps[appName];
            return appPermissions.includes(permission);
        }
        return false;
    };
    /**
     * check that user has a list of permissions
     * @param permissions
     * @param appName
     * @return boolean
     */
    BfAuthService.prototype.hasPermissions = function (permissions, appName) {
        if (appName === void 0) { appName = this.bfAuthConfig.Auth0.AppName; }
        if (this.role == 'Admin')
            return true;
        var havePermissions = new Array();
        if (this.profile && this.profile.app_metadata && this.profile.app_metadata.apps && appName && this.profile.app_metadata.apps.hasOwnProperty(appName) && permissions && permissions.length >= 1) {
            var appPermissions_1 = this.profile.app_metadata.apps[appName];
            permissions.forEach(function (permission) { havePermissions.push(appPermissions_1.includes(permission)); });
        }
        if (havePermissions.length >= 1)
            return havePermissions.every(function (permission) { return permission == true; });
        return false;
    };
    /**
     * check if user is authenticated
     * @return boolean
     */
    BfAuthService.prototype.authenticated = function () {
        var token = localStorage.getItem('id_token');
        var isExpired = BfAuthJwtHelper.isTokenExpired(token);
        return !isExpired;
    };
    ;
    /**
      * @method logout
      * and remove id_token, profile and all delegate token from local storage
      */
    BfAuthService.prototype.logout = function () {
        localStorage.removeItem('id_token');
        localStorage.removeItem('access_token');
        if (this.bfAuthConfig.DelegateClients && this.bfAuthConfig.DelegateClients.length > 0) {
            for (var i = 0; i < this.bfAuthConfig.DelegateClients.length; i++) {
                var delegateStored = "id_token_delegate_" + this.bfAuthConfig.DelegateClients[i].Auth0.AppName;
                localStorage.removeItem(delegateStored);
            }
        }
        this.router.navigate(["/"]).then(function (result) {
            window.location.href = window.location.origin;
        });
    };
    ;
    /**
      * set Delegate tokens observable if all delegate tokens are resolved
      * @param token
      */
    BfAuthService.prototype.setDelegateTokensAsync = function (idToken, accessToken) {
        var _this = this;
        var delegateTokens = new Array();
        if (this.bfAuthConfig.DelegateClients && this.bfAuthConfig.DelegateClients.length > 0) {
            this.bfAuthConfig.DelegateClients.forEach(function (delegate) {
                var delegateTokenId = "id_token_delegate_" + delegate.Auth0.AppName;
                var delegateTokenExist = localStorage.getItem(delegateTokenId);
                if (delegateTokenExist && !BfAuthJwtHelper.isTokenExpired(delegateTokenExist)) {
                    delegateTokens.push({ AppName: delegate.Auth0.AppName, id_token: delegateTokenExist });
                }
                else {
                    // legacy api so build token the old style way by calling the /delgate endpoint
                    if (delegate.Auth0.Legacy == true) {
                        _this.buildDelegateTokenAsync(idToken, delegate)
                            .subscribe(function (delegationToken) {
                            delegateTokens.push({ AppName: delegate.Auth0.AppName, id_token: delegationToken.id_token });
                            if (delegateTokens.length == _this.bfAuthConfig.DelegateClients.length)
                                _this.delegateTokensSubject.next(delegateTokens);
                        }, function (error) {
                            delegateTokens.push({ AppName: delegate.Auth0.AppName, Error: error });
                            if (delegateTokens.length == _this.bfAuthConfig.DelegateClients.length)
                                _this.delegateTokensSubject.next(delegateTokens);
                            _this.errorSubject.next({ source: 'Delegate result error', error: error });
                        });
                    }
                    // OIDC approach / the new way
                    // as we store the new token (because a non-expired one isn't available in app storage, we jsut store the *same* acess token passed for each API - it's actually the same thing for all)
                    // this is really just a work around as we won't need to store lots of different tokens anymore
                    else
                        delegateTokens.push({ AppName: delegate.Auth0.AppName, id_token: accessToken });
                    // this cheesey statement is to push an observerable list of tokens, once ALL tokens have been setup
                    if (delegateTokens.length == _this.bfAuthConfig.DelegateClients.length)
                        _this.delegateTokensSubject.next(delegateTokens);
                }
            });
        }
    };
    BfAuthService.prototype.loginCallbackHandler = function (error, profile, id_token, access_token, state) {
        if (error) {
            this.errorSubject.next({ source: 'auth0 login', error: error });
        }
    };
    BfAuthService.prototype.signUpErrorCallbackHandler = function (error) {
        if (error) {
            this.errorSubject.next({ source: 'auth0 signup', error: error });
        }
    };
    /**
     * Set User profile
     */
    BfAuthService.prototype.setProfileAsync = function (token) {
        var profile = BfAuthJwtHelper.decodeToken(token);
        if (profile) {
            this.readMetaData(profile);
            this.firstnameSubject.next(profile.given_name);
            this.surnameSubject.next(profile.family_name);
            this.pictureSubject.next(profile.picture);
            this.emailSubject.next(profile.email);
            this.profileSubject.next(profile);
        }
    };
    /**
     * Read the metadata object (original or OIDC) and wire up necessary observables
     * @param profile
     */
    BfAuthService.prototype.readMetaData = function (profile) {
        // this is the OIDC friendly app_metadata field from the rule tricked profile
        var oidcMetaData = profile["https://brafton.com/app_metadata"];
        // if OIDC metadata field exists - copy it into the profile.app_metadata field
        if (oidcMetaData)
            profile.app_metadata = oidcMetaData;
        if (profile.app_metadata) {
            try {
                this.setUserPermissions(profile.app_metadata);
            }
            catch (error) {
                this.errorSubject.next({ source: 'Permissions', error: error });
            }
            this.profileIdSubject.next(profile.app_metadata.profileId);
            this.roleSubject.next(profile.app_metadata.role);
            this.departmentSubject.next(profile.app_metadata.department);
            this.departmentIdSubject.next(profile.app_metadata.department_id);
        }
    };
    BfAuthService.prototype.setUserPermissions = function (appMetadata) {
        var appName = this.bfAuthConfig.Auth0.AppName;
        if (appMetadata && appMetadata.apps && appName && appMetadata.apps.hasOwnProperty(appName)) {
            var permissions = appMetadata.apps[appName];
            this.permissionsSubject.next(permissions);
        }
    };
    /**
     * store each with signature: id_token_delegate_<appName> in localstorage
     * @param token
     * @param delegateClient
     * @return Observable of auth0 Auth0DelegationToken
     */
    BfAuthService.prototype.buildDelegateTokenAsync = function (token, delegateClient) {
        var payload = {
            'client_id': this.bfAuthConfig.Auth0.ClientId,
            'grant_type': 'urn:ietf:params:oauth:grant-type:jwt-bearer',
            'id_token': token,
            'target': delegateClient.Auth0.ClientId,
            'scope': 'openid given_name family_name email picture app_metadata',
            'api_type': 'auth0'
        };
        return this.http.post("https://" + this.bfAuthConfig.Auth0.Domain + "/delegation", payload)
            .pipe(catchError(this.handleError()));
    };
    BfAuthService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            return of(result);
        };
    };
    BfAuthService.ngInjectableDef = i0.defineInjectable({ factory: function BfAuthService_Factory() { return new BfAuthService(i0.inject(i1.Router), i0.inject(i2.HttpClient), i0.inject(i3.BF_AUTH_CONFIG), i0.inject(i3.BF_AUTH_CONFIG_OPTIONS)); }, token: BfAuthService, providedIn: "root" });
    BfAuthService = __decorate([ __param(2, Inject(BF_AUTH_CONFIG)),
        __param(3, Inject(BF_AUTH_CONFIG_OPTIONS)),
        __metadata("design:paramtypes", [Router,
            HttpClient, Object, Object])
    ], BfAuthService);
BfAuthService.ɵfac = function BfAuthService_Factory(t) { return new (t || BfAuthService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(BF_AUTH_CONFIG), ɵngcc0.ɵɵinject(BF_AUTH_CONFIG_OPTIONS)); };
BfAuthService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BfAuthService, factory: function (t) { return BfAuthService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BfAuthService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.HttpClient }, { type: Object, decorators: [{
                type: Inject,
                args: [BF_AUTH_CONFIG]
            }] }, { type: Object, decorators: [{
                type: Inject,
                args: [BF_AUTH_CONFIG_OPTIONS]
            }] }]; }, null); })();
    return BfAuthService;
}());
export { BfAuthService };

